import './utilities';
import './menu-mobile-toggle';
import './menu-navigation';
import './big-word';
import './people-list';
import './timeline-slider';
import './footer-navigation';
//import './key-figures';
import './form';
import './scroll-info';
import './header-hp';
import './tabs-block';
import './contact-form-select';
import './contact-etab-select';
import './slideshow';
import './menu-animation';
import './wedoxa-tabs';